<template>
  <v-container fluid class="background pa-0">
    <v-container>
      <v-row>
        <v-col cols="12" class="footer_rights_text">
          <v-icon size="10" class="footer_rights_text mr-1 my-auto">
            mdi-copyright
          </v-icon>
          <span class="mr-5 my-auto">{{ footer.rights }}</span>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import lang from "../../lang/pt.json";

export default {
  name: "Footer",

  data: () => ({
    footer: lang.footer,
  }),
};
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

.background {
  background-color: map-get($theme-colors, "footer") !important;
  border-color: map-get($theme-colors, "footer") !important;
}

.footer_rights_text {
  color: map-get($theme-colors, "dark-blue") !important;
  font-family: "Roboto" !important;
  font-size: 12px;
  letter-spacing: 0;
}
</style>
